// Local translations
export const T = {
  en_GB: {
    suitability: "Suitability",
    onlyAllowSuitable: "Only allow suitable products",
    onlyAllowSuitableDesc: "Block form submission if the portfolio contains unsuitable products",
    fieldsDescription: "Choose which additional columns to display in the portfolio table.",
    isin: "ISIN",
    isinDesc: "Show the ISIN column in the table",
    productType: "Product Type",
    productTypeDesc: "Show the product type column in the table",
  },
  nb_NO: {
    suitability: "Egnethet",
    onlyAllowSuitable: "Tillat kun egnede produkter",
    onlyAllowSuitableDesc: "Blokkér skjemainnsending hvis porteføljen inneholder uegnede produkter",
    fieldsDescription: "Velg hvilke tilleggskolonner som skal vises i porteføljetabellen.",
    isin: "ISIN",
    isinDesc: "Vis ISIN-kolonnen i tabellen",
    productType: "Produkttype",
    productTypeDesc: "Vis produkttypekolonnen i tabellen",
  },
} as const;
